<template>
  <div v-if="customer">
    <!-- Carriers-->
    <div v-if="!current_workload">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h4>Carriers</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" v-for="carrier_type in carrier_types">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="carriers"
                  :value="carrier_type.carrier_code"
                  :id="carrier_type.carrier_code"
                />
                <label class="form-check-label" :for="carrier_type.carrier_code">{{ carrier_type.name }}</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="Object.keys(carriers).length >= 6">
            <div class="col">
              <div class="text-danger">You can only select up to five carriers</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Order Channels-->
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h4>Order Channels</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" v-for="orderChannelType in oc_types">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="order_channels"
                  :value="orderChannelType.key"
                  :id="orderChannelType.key"
                />
                <label class="form-check-label" :for="orderChannelType.key">{{ orderChannelType.value }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-right mt-3">
          <button
            class="btn btn-danger"
            @click="
              confirmModal(
                $event,
                $t('are_you_sure'),
                'Resetting a customer deletes ALL data on that account and cannot be undone.',
                reset
              )
            "
          >
            Reset Customer
          </button>
          <div class="text-muted">Choose at least 1 carrier and 1 order channel</div>
        </div>
      </div>
    </div>
    <div v-else>
      <h4 class="text-center">{{ current_workload }}</h4>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import clientApi from '@/store/clientapi';
import { mapState } from 'vuex';
import Alerts, { handle } from '@/utils/alerts';

export default {
  props: ['customer'],
  data() {
    return {
      carriers: [],
      order_channels: [],
      carrier_types: [],
      order_channel_types: [],
      oc_types: [
        { key: 'woo_commerce', value: 'Woocommerce' },
        { key: 'magento_2', value: 'Magento 2' },
        { key: 'prestashop', value: 'Prestashop' }
      ],
      step: 1,
      current_workload: false
    };
  },
  computed: {
    ...mapState(['currentTenant'])
  },
  async mounted() {
    let { data: token } = await Api.create('customer_tokens', {
      tenant: this.customer.tenant_name
    });
    this.$store.commit('setCurrentTenant', {
      tenantName: token.tenant,
      token: token.token,
      refreshToken: token.refresh_token,
      expiresAt: token.expires_at
    });

    Api.findAllPages('carrier_types', { sort: 'name' }).then(({ data: data }) => {
      this.carrier_types = data;
    });

    Api.findAllPages('order_channel_types').then(({ data: data }) => {
      this.order_channel_types = data;
    });
  },
  methods: {
    async sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    reset: handle(async function () {
      this.current_workload = 'Resetting customer';

      await clientApi.create('reset_customers', {});
      await this.generate();
    }),

    generate: async function () {
      // I know it's not techinally creating a user, but in the eyes of support is is
      this.current_workload = 'Generating User';

      // Create a new token after all were deleted in the previous step
      let { data: token } = await Api.create('customer_tokens', {
        tenant: this.customer.tenant_name
      });
      this.$store.commit('setCurrentTenant', {
        tenantName: token.tenant,
        token: token.token,
        refreshToken: token.refresh_token,
        expiresAt: token.expires_at
      });

      // Sender address
      this.current_workload = 'Creating new shipping addresses';
      const { data: sender_address } = await clientApi.create('shipping_addresses', this.address_config());

      // Carriers
      let created_carriers = [];

      for (let carrier of this.carriers) {
        let carrier_type = this.carrier_types.find((x) => x.carrier_code.trim() === carrier);
        this.current_workload = 'Configuring ' + carrier_type.name;

        let carrier_config = {
          alias: carrier_type.name,
          carrier_type: {
            id: carrier_type.id
          }
        };

        const { data: carr } = await clientApi.create('carriers', carrier_config);
        await this.sleep(500);

        created_carriers.push(carr);
      }

      // Order Channels

      for (let oc of this.order_channels) {
        this.current_workload = 'Configuring ' + oc;
        let config = this[oc + '_config']();
        config['sender_address'] = {
          id: sender_address.id
        };

        const { data: channel } = await clientApi.create('order_channels', config);

        const carrier = created_carriers[Math.floor(Math.random() * created_carriers.length)];

        // Shipping Rates
        this.current_workload = 'Configuring Shipping Rates';
        const { data: rate } = await clientApi.create('shipping_rates', this.shipping_rate_config(carrier, channel));

        // Orders
        for (let i = 0; i < 15 / Object.keys(this.order_channels).length; i++) {
          this.current_workload = 'Generating dummy order';

          let order_config = this.order_config(channel, i + 1, rate);
          const { data: ord } = await clientApi.create('orders', order_config);
          await this.sleep(100);

          if (Math.random() > 0.5) {
            let shipment_config = this.shipment_config(channel, rate, ord);

            this.current_workload = 'Adding shipment';
            let { data: shp } = await clientApi.create('shipments', shipment_config);
            await this.sleep(100);

            this.current_workload = 'Adding tracking events';
            let tracking_events = this.tracking_events_config(shp);

            for (let k = 0; k < tracking_events.length; k++) {
              await clientApi.create('tracking_events', tracking_events[k]);
              await this.sleep(100);
            }
          }
        }
      }

      this.current_workload = 'Done!';
    },

    /**
     * ******************
     * Address
     * ******************
     */
    address_config() {
      const addresses = ['Søndergade', 'Lyngbygade', 'Torvet', 'Diagonalstrædet', 'Frederiksberg allé'];
      const cities = ['Silkeborg', 'Copenhagen', 'Aarhus', 'Odense'];
      const zips = {
        Silkeborg: 8600,
        Copenhagen: 1050,
        Aarhus: 8200,
        Odense: 5000
      };

      const address = addresses[Math.floor(Math.random() * addresses.length)] + ' ' + Math.floor(Math.random() * 50);
      const city = cities[Math.floor(Math.random() * cities.length)];
      const zip = zips[city];

      return {
        address_1: address,
        city: city,
        zip: zip,
        country_code: 'DK',
        att_contact: 'Support',
        company_name: 'Webshipper'
      };
    },

    /**
     * ******************
     * Shipping rate
     * ******************
     */
    shipping_rate_config(carrier, order_channel) {
      return {
        name: 'Demo rate',
        carrier_service_code: 'Package',
        require_drop_point: false,
        is_return: false,
        carrier: carrier,
        order_channel: order_channel
      };
    },

    /**
     * ******************
     * Shipment
     * ******************
     */
    shipment_config(order_channel, shipping_rate, order) {
      return {
        order: order,
        status: status,
        visible_ref: order.ext_ref,
        service_code: shipping_rate.carrier_service_code,
        shipping_rate: shipping_rate,
        billing_address: _.omit(order.billing_address, ['type']),
        delivery_address: _.omit(order.delivery_address, ['type']),
        sender_address: _.omit(order.sender_address, ['type']),
        packages: [
          {
            weight: 3050,
            order_lines: order.order_lines.map((x) => _.pick(x, ['id']))
          }
        ]
      };
    },

    tracking_events_config(shipment) {
      let date_1 = new Date();
      date_1.setDate(date_1.getDate() - 2);
      date_1.setHours(11);

      let date_2 = new Date();
      date_2.setDate(date_2.getDate() - 2);
      date_2.setHours(12);

      let date_3 = new Date();
      date_3.setDate(date_3.getDate() - 1);
      date_3.setHours(4);

      let date_4 = new Date();
      date_4.setDate(date_4.getDate());
      date_4.setHours(15);

      return [
        {
          tracking_link_id: shipment.tracking_links[0].id,
          shipment: shipment,
          package: shipment.packages[0],
          status: 'information_received',
          description: 'The Parcel Data was entered into the IT system and will start its journey soon',
          time: date_1.toISOString(),
          event_id: 2,
          location: 'Webshipper'
        },
        {
          tracking_link_id: shipment.tracking_links[0].id,
          shipment: shipment,
          package: shipment.packages[0],
          status: 'dispatched',
          description: 'The Parcel has been dispatched towards its destination',
          time: date_2.toISOString(),
          event_id: 3,
          location: 'Webshipper',
          latitude: 56.168726,
          longitude: 9.549449
        },
        {
          tracking_link_id: shipment.tracking_links[0].id,
          shipment: shipment,
          package: shipment.packages[0],
          status: 'in_transit',
          description: 'The Parcel is under transportation',
          time: date_3.toISOString(),
          event_id: 4,
          location: 'Taulov Pakkecenter',
          latitude: 55.543081,
          longitude: 9.630147
        },
        {
          tracking_link_id: shipment.tracking_links[0].id,
          shipment: shipment,
          package: shipment.packages[0],
          status: 'delivered',
          description: 'The Parcel has been delivered',
          time: date_4.toISOString(),
          event_id: 5,
          location: 'Innovatorium',
          latitude: 56.128805,
          longitude: 9.025561
        }
      ];
    },

    /**
     * ******************
     * Order
     * ******************
     */
    order_config(order_channel, idx, shipping_rate) {
      const currencies = ['DKK', 'GBP', 'EUR'];
      const rollerblade_colors = ['Burning Flames', 'Night-sky', 'Pink', 'Red', 'Golden'];

      return {
        status: 'pending',
        currency: currencies[Math.floor(Math.random() * currencies.length)],
        ext_ref: order_channel.channel_label + '-' + idx,
        delivery_address: this.address_config(),
        sender_address: this.address_config(),
        order_channel: order_channel,
        shipping_rate: shipping_rate,
        order_lines: [
          {
            description: 'Giftcard',
            sku: 'SKU-' + Math.floor(Math.random() * 100),
            quantity: 2,
            country_of_origin: 'DK',
            unit_price: 12.0,
            vat_percent: 20,
            weight: 1000
          },
          {
            description: 'Snapback',
            sku: 'SNAP.231',
            quantity: 1,
            country_of_origin: 'DK',
            unit_price: 5.0,
            vat_percent: 20,
            weight: 250
          },
          {
            description: 'A Pair Of Rollerblades',
            sku: 'ROLLBL.532',
            quantity: 1,
            country_of_origin: 'DK',
            unit_price: 80.0,
            vat_percent: 20,
            weight: 800,
            additional_attributes: {
              Color: rollerblade_colors[Math.floor(Math.random() * rollerblade_colors.length)]
            }
          }
        ]
      };
    },

    /**
     * ******************
     * Order Channels
     * ******************
     */
    woo_commerce_config() {
      let order_channel_type = this.order_channel_types.find((x) => x.name.trim() === 'WooCommerce');

      if (!order_channel_type) {
        throw 'Order channel WooCommerce not found';
      }

      return {
        channel_label: 'WooCommerce',
        attrs: [
          {
            attr_key: 'url',
            attr_value: 'http://test.webshipr.com/woocommerce',
            attr_name: 'Store URL',
            attr_type: 'string'
          },
          {
            attr_key: 'consumer_key',
            attr_value: 'ck_c22c783d1bef4e87644b318ba5c0a05ec96f375e',
            attr_name: 'Consumer Key',
            attr_type: 'string'
          },
          {
            attr_key: 'consumer_secret',
            attr_value: 'cs_fe497505231ce5671426136e546da27b39749c05',
            attr_name: 'Consumer Secret',
            attr_type: 'string'
          },
          {
            attr_key: 'transfer_status',
            attr_value: 'processing',
            attr_name: 'Transfer Status',
            attr_type: 'string'
          },
          {
            attr_key: 'weight_unit',
            attr_value: 'g',
            attr_name: 'Weight unit',
            attr_type: 'string'
          }
        ],
        order_channel_type: {
          id: order_channel_type.id
        }
      };
    },
    magento_2_config() {
      let order_channel_type = this.order_channel_types.find((x) => x.name.trim() === 'Magento2');

      if (!order_channel_type) {
        throw 'Order channel WooCommerce not found';
      }

      return {
        channel_label: 'Magento2',
        attrs: [
          {
            attr_key: 'uri',
            attr_value: 'http://test.webshipr.com/magento2',
            attr_name: 'Store URL',
            attr_type: 'string'
          },
          {
            attr_key: 'store_id',
            attr_value: '1',
            attr_name: 'Shop ID',
            attr_type: 'string'
          },
          {
            attr_key: 'access_token',
            attr_value: 'ueldu2xhox8ktmjxmnrxuloquh9hida0',
            attr_name: 'Access Token',
            attr_type: 'string'
          },
          {
            attr_key: 'transfer_status',
            attr_value: 'pending',
            attr_name: 'Transfer Status',
            attr_type: 'string'
          }
        ],
        order_channel_type: {
          id: order_channel_type.id
        }
      };
    },
    prestashop_config() {
      let order_channel_type = this.order_channel_types.find((x) => x.name.trim() === 'Prestashop');

      if (!order_channel_type) {
        throw 'Order channel WooCommerce not found';
      }

      return {
        channel_label: 'Prestashop',
        attrs: [
          {
            attr_key: 'uri',
            attr_value: 'test.webshipr.com/prestashop16-2',
            attr_name: 'URI',
            attr_type: 'string'
          },
          {
            attr_key: 'api_token',
            attr_value: 'SE39UFD99QLSTHPUGEC7W3LMXTG3ART8',
            attr_name: 'API Key',
            attr_type: 'string'
          },
          {
            attr_key: 'weight_unit',
            attr_value: 'kg',
            attr_name: 'Weight unit',
            attr_type: 'string'
          },
          {
            attr_key: 'transfer_status',
            attr_value: '1',
            attr_name: 'Transfer status',
            attr_type: 'string'
          },
          {
            attr_key: 'store_id',
            attr_value: '1',
            attr_name: 'Store ID',
            attr_type: 'string'
          },
          {
            attr_key: 'close_id',
            attr_value: '4',
            attr_name: 'Close ID',
            attr_type: 'string'
          }
        ],
        order_channel_type: {
          id: order_channel_type.id
        }
      };
    }
  }
};
</script>
